import React from 'react'

const NotFoundPage = () => {
  return (
    <div className='my-[30vh] bg-black text-center  p-5'>
    <h2>404: Page Not Found in This Timeline</h2>
    
  </div>
  )
}

export default NotFoundPage